import styled from "styled-components";
import BaseComponent from "../Base/BaseComponent";

const Paper = styled(BaseComponent)`
  box-shadow: ${({ elevation, theme }) => theme.elevation[elevation]};
`;

export default Paper;
